import {Type} from '@angular/core';
import {TerminalResponse} from './response.model';
import { classToPlain } from 'class-transformer';


export abstract class Request {

    constructor() {
    }

    public serialize(): string {
        return JSON.stringify(classToPlain(this));

    }

    public deserializerClass(): Type<TerminalResponse> {
        return TerminalResponse;
    }
}
